import { render } from "./DiscountAction.vue?vue&type=template&id=594974fe"
import script from "./DiscountAction.vue?vue&type=script&lang=js"
export * from "./DiscountAction.vue?vue&type=script&lang=js"

import "./DiscountAction.vue?vue&type=style&index=0&id=594974fe&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__